import React from "react"

import { Navigation } from "components/navigation"
import { useAppUI } from "providers/ui"

export const AppNavigation = () => {
  const { kioskNavigation, matchedPath } = useAppUI()
  return <Navigation value={matchedPath?.to} navigations={kioskNavigation} />
}
